import { InjectionToken } from '@angular/core';
import type { CardOperation } from './card.types';

export const FUNDING_SIGNATURE_TTL_MS = 5 * 60_000;

export interface CardGasEstimateInput {
  readonly walletId: string;
  readonly amountRaw?: bigint;
}

export interface CardGasRequirement {
  readonly requiredRaw: bigint;
  readonly decimals: number;
}

export interface CardFundingSigner {
  sign(operation: CardOperation, pin: string): Promise<void>;

  estimateGas(input: CardGasEstimateInput): Promise<CardGasRequirement | null>;
}

export const CARD_FUNDING_SIGNER = new InjectionToken<CardFundingSigner>('CARD_FUNDING_SIGNER');

export function signatureDeadline(operation: CardOperation): number {
  return new Date(operation.createdAt).getTime() + FUNDING_SIGNATURE_TTL_MS;
}

export function signatureSecondsLeft(operation: CardOperation, now = Date.now()): number {
  const deadline = signatureDeadline(operation);
  if (!Number.isFinite(deadline)) return Math.ceil(FUNDING_SIGNATURE_TTL_MS / 1000);
  return Math.max(0, Math.ceil((deadline - now) / 1000));
}

export interface CardFreshToken {
  freshToken(pin: string): Promise<string>;
}

export const CARD_FRESH_TOKEN = new InjectionToken<CardFreshToken>('CARD_FRESH_TOKEN');

export class MissingFundingIntentError extends Error {
  readonly errorKey = 'cards.errors.fundingIntentMissing';
}
